import { Component, Input } from '@angular/core';
import { ClaimDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/claim-dto';
import Utils from 'src/app/helpers/utils';

@Component({
  selector: 'app-claim-total',
  templateUrl: './claim-total.component.html',
  styleUrl: './claim-total.component.scss'
})
export class ClaimTotalComponent {
  @Input() claimDto!: ClaimDto;
  @Input() repairTotal!: number;
  @Input() claimTotalCssClass: string = '';

  dollarTotals: ClaimDollarTotals = {
    subTotal: 0,
    tax: 0,
    total:  0,
    deductible: 0,
  }
  
  constructor(private utils: Utils) {
  }
  ngOnInit() {
    this.dollarTotals = this.utils.calculateClaimTotals(this.claimDto!, this.repairTotal);
  }
}

export type ClaimDollarTotals = {
  subTotal: number;
  tax: number;
  total: number;
  deductible: number;
}
